import { useQuery } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse/types'
import {
  PulsePositionTypes,
  getPulsePositionTypes,
} from 'api/pulse/pulsePositionTypes'
import { getPulsePositionTypesKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePulsePositionTypes(query: PulseFilters) {
  return useQuery<PulsePositionTypes>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPulsePositionTypesKey(query),
    queryFn: ({ signal }) => getPulsePositionTypes(query.companyIds, signal),
    enabled: !!query.companyIds?.length,
  })
}
